import { createBrowserRouter } from "react-router-dom";
import { AppLayout, LoginLayout } from "../components/common/layout";
import {
  BeneficiaryFilePage,
  BeneficiaryFileStatusPage,
  BeneficiaryServicesPage,
  DashboardPage,
  LoginPage,
} from "../pages";
import {
  ROUTE_BENEFICIARY_FILE_LABEL,
  ROUTE_BENEFICIARY_FILE_STATUS_LABEL,
  ROUTE_BENEFICIARY_SERVICES_LABEL,
  ROUTE_DASHBOARD_LABEL,
  ROUTE_LOGIN,
} from "./routes";

const ROUTE_INDEX_PATH = "/";
const ROUTE_BENEFICIARY_PATH = "beneficiary/:beneficiaryId";
const ROUTE_BENEFICIARY_SERVICES_PATH = "services";
const ROUTE_BENEFICIARY_FILE_STATUS_PATH = "status";

const router = createBrowserRouter([
  {
    path: ROUTE_INDEX_PATH,
    element: <AppLayout />,
    handle: {
      crumb: ROUTE_DASHBOARD_LABEL,
    },
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: ROUTE_BENEFICIARY_PATH,
        handle: {
          crumb: ROUTE_BENEFICIARY_FILE_LABEL,
        },
        children: [
          {
            index: true,
            element: <BeneficiaryFilePage />,
          },
          {
            path: ROUTE_BENEFICIARY_SERVICES_PATH,
            handle: {
              crumb: ROUTE_BENEFICIARY_SERVICES_LABEL,
            },
            children: [
              {
                index: true,
                element: <BeneficiaryServicesPage />,
              },
              {
                path: ROUTE_BENEFICIARY_FILE_STATUS_PATH,
                element: <BeneficiaryFileStatusPage />,
                handle: {
                  crumb: ROUTE_BENEFICIARY_FILE_STATUS_LABEL,
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: ROUTE_LOGIN,
    element: <LoginLayout />,
    children: [{ index: true, element: <LoginPage /> }],
  },
]);

export default router;
